<template>
  <div class="star">
    <svg class="star-star" :class="{'star-star--color': ten > 0}" viewbox="0 0 12.52 12" width="1252" height="1200" preserveAspectRatio="xMinYMid"><g><path class="cls-1" d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"/></g></svg>
    <svg class="star-star" :class="{'star-star--color': ten > 1}" viewbox="0 0 12.52 12" width="1252" height="1200" preserveAspectRatio="xMinYMid"><g><path class="cls-1" d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"/></g></svg>
    <svg class="star-star" :class="{'star-star--color': ten > 2}" viewbox="0 0 12.52 12" width="1252" height="1200" preserveAspectRatio="xMinYMid"><g><path class="cls-1" d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"/></g></svg>
    <svg class="star-star" :class="{'star-star--color': ten > 3}" viewbox="0 0 12.52 12" width="1252" height="1200" preserveAspectRatio="xMinYMid"><g><path class="cls-1" d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"/></g></svg>
    <svg class="star-star" :class="{'star-star--color': ten > 4}" viewbox="0 0 12.52 12" width="1252" height="1200" preserveAspectRatio="xMinYMid"><g><path class="cls-1" d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"/></g></svg>
    <svg
      v-if="one !== 0"
      class="star-star star-point"
      :class="[`star-point--ten-${ten}`, `star-point--one-${one}`]"
      viewbox="0 0 12.52 12" preserveAspectRatio="xMinYMid"
    ><use xlink:href="#star" /></svg>
  </div>
</template>

<script>
export default {
  name: 'PartLogo',
  props: {
    ten: {
      type: Number
    },
    one: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
.star {
  display: flex;
  width: 80/375 * 100vw;
  position: relative;
  @include media() {
    width: 80px;
  }
  &-star {
    width: 12/375 * 100vw;
    height: 12/375 * 100vw;
    margin: 0 2/375 * 100vw;
    fill: #ccc;
    @include media() {
      width: 12px;
      height: 12px;
      margin: 2px;
    }
    &--color {
      fill: #DF0168;
    }
  }
  &-point {
    fill: #DF0168;
    position: absolute;
    top: 0;
    &--ten {
      @for $i from 0 through 4 {
        &-#{$i} {
          left: $i * 16/375 * 100vw;
          @include media() {
            left: $i * 16px;
          }
        }
      }
    }
    &--one {
      @for $i from 1 through 9 {
        &-#{$i} {
          width: ($i * 10) * 12/375 * 1vw;
          @include media(){
            width: floor(12 / 10 * $i * 1px);
          }
        }
      }
    }
  }
}
</style>